import { WatchQueryFetchPolicy } from 'apollo-client';
import gql from 'graphql-tag';
import { useMutation } from 'react-apollo';

export const useDeleteDocumentMutation = (fetchPolicy?: WatchQueryFetchPolicy) => {

    const [deleteData, deleteDocumentResult] = useMutation<DeleteDocumentMutationData, DeleteDocumentMutationParams>(DeleteDocumentMutation);

    return {...deleteDocumentResult, deleteData};
};

export interface DeleteDocumentMutationParams {
    documentId: number; 
    matterId: number;
}

export interface DeleteDocumentMutationData {
    deleteDocument: DeleteDocument;
}

export interface DeleteDocument {
    error:  null;
    status: boolean;
}

const DeleteDocumentMutation = gql`
    mutation DeleteDocument($documentId: Int, $matterId: Int) {
        deleteDocument(documentId: $documentId, matterId: $matterId) {
            error
            status
        }
    }
`;